import { ChangeDetectionStrategy, Component, Input, ChangeDetectorRef, OnChanges, SimpleChanges, inject } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

import { StLoaderSvgComponent } from '~/dash/core/st-loader-svg/st-loader-svg.component';

@Component({
  selector: 'app-img-loading',
  standalone: true,
  templateUrl: './img-loading.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage, StLoaderSvgComponent],
})
export class ImgLoadingComponent implements OnChanges {
  private readonly ref = inject(ChangeDetectorRef);

  @Input()
  public height = 'auto';

  @Input()
  public width = 'auto';

  @Input()
  public src: string;

  @Input()
  public alt: string;

  @Input()
  public title: string;

  public isLoading = true;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.src) {
      this.isLoading = true;
      this.ref.markForCheck();
    }
  }

  public hideLoader(event) {
    if (event.target.naturalWidth > 1 && event.target.naturalHeight > 1) {
      this.isLoading = false;
      this.ref.markForCheck();
    } else {
      this.isLoading = true;
      this.ref.markForCheck();
    }
  }
}
